import { render } from "./SelectWidget.vue?vue&type=template&id=bc6ab74e&ts=true&lang=pug"
import script from "./SelectWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectWidget.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__